import React from 'react';
import { InfoSection, Pricing  } from '../../components';
import Elevators from '../../components/InfoSection/elevators';
// import { ElevatorsOne, ElevatorsTwo, ElevatorsThree, ElevatorsFour } from './Data';

function elevators() {
  return (
    <>
    <Pricing />
    <Elevators />
    
      {/* <InfoSection {...ElevatorsOne} />
      <InfoSection {...ElevatorsTwo} />
      <InfoSection {...ElevatorsThree} />
     <InfoSection {...ElevatorsFour} /> */}


    </>
  );
}

export default elevators;
